import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';

@Component({
  selector: 'error-modal',
  standalone: true,
  imports: [
    ErrorDialogComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss'
})
export class ErrorModalComponent {
  onClose = output<void>();

  message = input.required({ transform: this.#messageLine });

  title = input('Opción no disponible');
  visible = input(false);



  onClosedDialog() {
    this.onClose.emit();
  }


  #messageLine(value: string | string[]): string[] {
    return Array.isArray(value) ? value : [value]
  }
}
